import { ACTION_CREATE, ACTION_EDIT } from '../../request';
import { Voter } from '../voter';

export class MessengersVoter extends Voter {
    supports(request) {
        return request.role === 'basic' && request.resource === 'messengers' && this.supportsVersion(request, '>=2.11');
    }

    vote(request) {
        if (request.includes(ACTION_CREATE)) {
            if (!this.canEdit(request)) {
                return false;
            }
        }

        if (request.includes(ACTION_EDIT)) {
            if (!this.canEdit(request)) {
                return false;
            }
        }

        return true;
    }

    canEdit({ workspace, subject }) {
        if (!subject) {
            return true;
        }

        const enabled = workspace.card.messengers.find((m) => m.enabled);

        return !(enabled && enabled.messenger !== subject.messenger);
    }
}
